import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#32c5f8',
        secondary: '#c2edfd',
        accent: '#c2edfd',
        // error: '#ffffff',
      },
    },
  },
});
